import { render, staticRenderFns } from "./StartupEditContacts.vue?vue&type=template&id=593a61e1&scoped=true"
import script from "./StartupEditContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./StartupEditContacts.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593a61e1",
  null
  
)

export default component.exports